<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ valid, errors }" mode="lazy" :vid="vid">
    <label :for="name" class="block text-sm font-medium leading-5 text-gray-700" v-if="label">
      {{label}}
    </label>
    <div class="mt-1 relative rounded-md shadow-sm">
      <input
        :name="name"
        :type="type"
        :value="value"
        class="form-input block w-full sm:text-sm sm:leading-5"
        :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:ring-red' : errors.length > 0 }"
        v-on:input="$emit('input', $event.target.value)"
      >
    </div>
    <p class="mt-2 text-sm text-red-600">{{errors[0]}}</p>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      required: true
    },
    optional: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    vid: {
      type: String,
      required: false
    }
  }
}
</script>
